import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import auth from "../auth";

Vue.use(VueRouter);

async function requireAuth(to, from, next) {
  let isAuthenticated = false;

  if (store.state.isLogged) {
    isAuthenticated = true;
  } else {
    let user = auth.getUserLogged();
    if (user != null) {
      const activeUser = await auth.stillLogged(user);
      if (activeUser) {
        isAuthenticated = true;
      }
    }
  }

  if (isAuthenticated) {
    next(); // allow to enter route
  } else {
    next("/login"); // go to '/login';
  }
}

async function requireLevel(to, from, next) {
  // let isAuthenticated = false;
  let isLevel = false;

  if (store.state.isLogged) {
    // isAuthenticated = true;
    if (store.state.loggedUser.level) {
      isLevel = true;
    }
  }
  if (isLevel == false) {
    let user = auth.getUserLogged();
    if (user != null) {
      const activeUser = await auth.stillLogged(user);
      if (activeUser) {
        // isAuthenticated = true
        isLevel = activeUser.level == 1;
      }
    }
  }

  if (isLevel) {
    next(); // allow to enter route
  } else {
    next("/"); // cancel navigation
  }
}

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/docentes",
    name: "Docentes",
    component: () => import("../views/Docentes.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/tronco-comun",
    name: "TroncoComun",
    component: () => import("../views/TroncoComun.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/carreras",
    name: "Carras",
    component: () => import("../views/Carreras.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/reconnect",
    name: "ReConnect",
    component: () => import("../views/ReConnect.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: () => import("../views/Perfil.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/periodos",
    name: "Periodos",
    component: () => import("../views/Periodos.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/grupos",
    name: "Grupos",
    component: () => import("../views/Grupos.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/carga-academica/:periodoSeleccionado",
    name: "CargaAcademica",
    component: () => import("../views/CargaAcademica.vue"),
    beforeEnter: requireAuth,
    props: true,
  },
  {
    path: "/tutorias/:periodoSeleccionado",
    name: "Tutorias",
    component: () => import("../views/Tutorias.vue"),
    beforeEnter: requireAuth,
    props: true,
  },
  {
    path: "/carga-academica-por-docente/:periodoSeleccionado",
    name: "CargaPorDocente",
    component: () => import("../views/CargaPorDocente.vue"),
    beforeEnter: requireAuth,
    props: true,
  },
  {
    path: "/respalda/:periodoSeleccionado",
    name: "Respaldo",
    component: () => import("../views/Respaldo.vue"),
    beforeEnter: requireAuth,
    props: true,
  },
  {
    path: "/restablece/:periodoSeleccionado",
    name: "Restaurar",
    component: () => import("../views/Restaurar.vue"),
    beforeEnter: requireAuth,
    props: true,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
